<app-help-page mainVideo="attribution-set-up"
               [tutorials]="['data-driven-attribution', 'url-templates', 'script-installation-checking']"
               [videos]="['attribution-set-up', 'attribution-script', 'tracking-templates']"></app-help-page>
